import { Component, ChangeDetectionStrategy, input, output, signal, ElementRef, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { XmedicalUiModule } from '@xmedical/ui';
import { ImageViewComponent } from '../image-view/image-view.component';

export type Orientation = 'landscape' | 'portrait' | 'square';

/**
 * Event emitted when the user selects a file for upload.
 * The parent is responsible for uploading the file and updating the imageUrl input.
 */
export interface ImageUploadRequest {
  file: File;
}

@Component({
  selector: 'xmed-image-uploader',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, XmedicalUiModule, ImageViewComponent],
  templateUrl: './image-uploader.component.html',
  styleUrl: './image-uploader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageUploaderComponent {
  private readonly fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');

  orientation = input<Orientation>('landscape');
  imageUrl = input<string>('');
  uploading = input<boolean>(false);

  uploadRequested = output<ImageUploadRequest>();
  removeRequested = output<void>();

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadRequested.emit({ file: input.files[0] });
      input.value = '';
    }
  }

  openFileInput(event: MouseEvent): void {
    event.stopPropagation();
    this.fileInput()?.nativeElement.click();
  }

  removeImage(): void {
    this.removeRequested.emit();
  }
}
